<template>
    <div class="flex h-screen overflow-hidden">
        <aside
            class="fixed top-0 left-0 xl:static w-70 border-r border-gray-200 h-screen flex flex-col bg-white z-2 transition-all duration-300 xl:transition-none xl:translate-x-0"
            :class="{ '-translate-x-full': !showNav }"
        >
            <MainNav />
        </aside>
        <div class="flex flex-1 flex-col w-full">
            <div
                class="fixed top-0 left-0 h-screen w-full bg-gray-900/50 z-1 xl:hidden"
                :class="{ block: showNav, hidden: !showNav }"
                @click.prevent="showNav = false"
            ></div>
            <header class="sticky top-0 z-10 shrink-0 flex h-16 bg-white border-b border-gray-200">
                <button
                    type="button"
                    @click.prevent="showNav = !showNav"
                    class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 2xl:hidden"
                >
                    <Icon icon="boxicons:menu-left" class="block h-6 w-6" v-if="!showNav" />
                    <Icon icon="boxicons:x" class="block h-6 w-6" v-else />
                </button>
                <div class="flex-1 px-4 flex justify-between">
                    <div class="flex-1 flex"></div>
                    <div class="ml-4 flex items-center lg:ml-6">
                        <router-link :to="`/users/${auth.user?.id}/update`" class="decoration-none flex items-center text-gray-500 text-sm hover:text-gray-700">
                            <Icon icon="carbon:user-filled" :inline="true" class="text-base" />
                            <span class="is-block ml-1">{{ auth.user?.name }}</span>
                        </router-link>

                        <button
                            type="button"
                            @click.prevent="logout"
                            class="bg-white border-0 p-2 ml-2 cursor-pointer text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            <span class="sr-only">Logout</span>
                            <Icon icon="fontisto:power" :inline="true" />
                        </button>
                    </div>
                </div>
            </header>
            <main class="flex-1 overflow-y-auto">
                <div class="p-4 lg:p-6">
                    <slot />
                </div>
                <div class="p-4 lg:p-6 pt-0! text-right text-xs text-gray-500">Version: {{ version }}</div>
            </main>
        </div>
    </div>
</template>
<script setup lang="ts">
import { Icon } from '@iconify/vue';
import { useAsync, useCategory, useConfig, useLocation } from '@/composables';
import { useAuthStore } from '@/stores';
import { AuthService } from '@/services';
import { useRoute, useRouter } from 'vue-router';
import { ref, watch } from 'vue';
import MainNav from '@/components/MainNav.vue';
const router = useRouter();
const route = useRoute();
const auth = useAuthStore();

const { fetch: fetchCategories } = useCategory();
const { fetch: fetchLocations } = useLocation();
const { refresh } = useConfig();

const showNav = ref(false);

watch(
    () => route.path,
    () => {
        showNav.value = false;
    }
);

const { fn: logout } = useAsync(async () => {
    await AuthService.signOut();
    auth.signout();
    router.replace({ name: 'login' });
});

refresh();
fetchCategories();
fetchLocations();

const version = import.meta.env.VITE_APP_VERSION;
</script>
